import { DepartmentFile } from '../../../../Models/Departments/Details/file';
import FilesInfo from '../../../Details/Components/Department/Components/ServePreference/Components/FilesInfo';

export default function DepartmentEditOldFiles({
  form,
}: {
  form: any;
}) {
  const onRemoveFile = (id: any) => {
    const index = form.values.custodianDetails.servePreferences.oldFiles.findIndex(
      (f: DepartmentFile) => f.id === id,
    );
    if (index > -1) {
      const oldFilesToBeDeleted = [
        ...form.values.custodianDetails.servePreferences
          .oldFilesToBeDeleted,
      ];
      oldFilesToBeDeleted.push(
        form.values.custodianDetails.servePreferences.oldFiles[
          index
        ],
      );
      form.setFieldValue(
        `custodianDetails.servePreferences.oldFilesToBeDeleted`,
        oldFilesToBeDeleted,
      );
      const oldFiles = [
        ...form.values.custodianDetails.servePreferences.oldFiles,
      ];
      oldFiles.splice(index, 1);
      form.setFieldValue(
        `custodianDetails.servePreferences.oldFiles`,
        oldFiles,
      );
    }
  };
  return form?.values?.custodianDetails?.servePreferences?.oldFiles &&
    form.values.custodianDetails.servePreferences.oldFiles.length >
      0 ? (
    <FilesInfo
      files={
        form.values.custodianDetails.servePreferences.oldFiles
      }
      onRemoveFile={onRemoveFile}
    />
  ) : null;
}
